import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-navy rounded-t-[40px] mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 border-2 border-gold rounded-lg flex items-center justify-center bg-primary-dark">
                <img 
                  src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/aedf53178de89724821e4a867150a58e.png" 
                  alt="Deniz Erin" 
                  className="w-10 h-10 object-contain"
                />
              </div>
              <span className="font-serif text-xl font-bold text-white">Deniz Erin</span>
            </div>
            <p className="text-sm italic text-text-light mb-6">
              Yıldızlardan Ruha Köprü
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.instagram.com/astrolojidenizerin/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                aria-label="TikTok"
              >
                <i className="fab fa-tiktok text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-bold text-white mb-6">Keşfet</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/hakkimda"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  Hakkımda
                </Link>
              </li>
              <li>
                <Link
                  to="/hizmetler"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link
                  to="/egitimler"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  Eğitimler
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/sss"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  S.S.S.
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-bold text-white mb-6">Danışmanlık</h4>
            <ul className="space-y-3">
              {[
                'Astrolojik Danışmanlık',
                'Spiritüel Danışmanlık',
                'Şifa & Enerji Çalışmaları',
                'Doğum Haritası Analizi',
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/hizmetler"
                    className="text-sm text-text-light hover:text-gold hover:translate-x-1 transition-all duration-300 inline-block cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-base font-bold text-white mb-3">Haberdar Olun</h4>
            <p className="text-sm text-text-light mb-4">
              Yeni içerikler için abone olun
            </p>
            <form className="flex items-center" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-3 bg-primary-dark border border-gold/30 rounded-l-full text-sm text-white placeholder-text-light focus:outline-none focus:border-gold transition-colors duration-300"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-gold rounded-r-full text-primary-dark hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                aria-label="Abone Ol"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gold/20">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-xs text-text-light">
              © {currentYear} Deniz Erin. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center space-x-6 text-xs text-text-light">
              <Link to="/gizlilik" className="hover:text-gold transition-colors duration-300 cursor-pointer">
                Gizlilik
              </Link>
              <span>|</span>
              <Link to="/kvkk" className="hover:text-gold transition-colors duration-300 cursor-pointer">
                KVKK
              </Link>
              <span>|</span>
              <Link to="/mesafeli-satis" className="hover:text-gold transition-colors duration-300 cursor-pointer">
                Mesafeli Satış
              </Link>
              <span>|</span>
              <a
                href="https://www.webkitdesign.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-white rounded-lg px-3 py-1.5 hover:shadow-lg hover:shadow-white/20 transition-all duration-300 cursor-pointer"
                aria-label="WebKit Design"
              >
                <img
                  src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/46b55f8638cfa8a6229f6908271071a3.png"
                  alt="WebKit Design"
                  className="h-4 w-auto object-contain"
                />
              </a>
            </div>
          </div>
          <p className="text-xs text-text-light mt-6 text-center">
            <strong>Önemli Uyarı:</strong> Sunulan hizmetler tıbbi, psikolojik veya hukuki danışmanlık yerine geçmez.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;